<template>
  <div id="mm-prv-read-wdg" >

    <div >
      <privacy />
      <div class="mm-prv-read-wdg-email-container">
        <div class="mm-prv-read-wdg-request-text"><label >{{term.requestText}}</label></div>

          <div><label class="mm-prv-read-wdg-email-label">E-mail:</label></div>
          <input type="text" class="mm-prv-read-wdg-email" placeholder="E-mail" v-model="email" name="email">
          <button  :disabled="!enableButton" @click="sendRequest">{{term.captionText}}</button>
      </div>
    </div>

    <div v-if="mailSent">
      <div class="alert">
        <svg enable-background="new 0 0 32 32" height="20px"  version="1.1" viewBox="0 0 32 32" width="20px" xml:space="preserve" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink"><g id="Check_Circle"><path d="M16,0C7.163,0,0,7.163,0,16c0,8.837,7.163,16,16,16c8.836,0,16-7.164,16-16C32,7.163,24.836,0,16,0z M16,30   C8.268,30,2,23.732,2,16C2,8.268,8.268,2,16,2s14,6.268,14,14C30,23.732,23.732,30,16,30z" fill="green"/><path d="M23.3,10.393L13.012,20.589l-4.281-4.196c-0.394-0.391-1.034-0.391-1.428,0   c-0.395,0.391-0.395,1.024,0,1.414l4.999,4.899c0.41,0.361,1.023,0.401,1.428,0l10.999-10.899c0.394-0.39,0.394-1.024,0-1.414   C24.334,10.003,23.695,10.003,23.3,10.393z" fill="green"/></g><g/><g/><g/><g/><g/><g/></svg>
        <span class="email-sent-text">{{term.successText}}</span>
      </div>
    </div>
  </div>
</template>

<script>
import {mapState, mapActions, mapMutations} from 'vuex'
import Privacy from './components/Privacy'

export default {
  name: 'App',
  watch: {
    'email' () {
      // if (this.mailSent) { this.setMailSent(false) }
    }
  },
  data () {
    return {
      email: '',
      disable: false
    }
  },
  components: {
    Privacy
  },
  props: ['id'],
  methods: {
    ...mapMutations(['setMailSent']),
    ...mapActions(['send']),
    sendRequest () {
      this.disable = true
      this.send({email: this.email})
        .then(() => { this.email = null })
        .then(() => { this.disable = false })
    }
  },
  computed: {
    enableButton () {
      if (!this.email) { return false }
      if (this.disable) { return false }

      return true
    },
    ...mapState(['version', 'owner', 'site', 'ownerId', 'baseURL', 'term', 'mailSent', 'isAjax'])
  }
}
</script>

<style lang="scss">
  #mm-prv-read-wdg {
    $ge-padding:6px;
    font-family: 'Avenir', Helvetica, Arial, sans-serif;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
    color: #2c3e50;

    .alert {
      padding:12px;
      background-color: #C8E6C9;
      margin-bottom:30px;
      border-radius: 4px;
    }

    button {
      border: 1px solid silver;
      padding: $ge-padding;
      font-size:13px;
      min-width: 100px;
      background-color: #4FC3F7;
      font-weight: bold;
      color:white;
      text-transform: uppercase;
    }
    label {
      font-size:12px;
      font-weight: bold;

    }
    .mm-prv-read-wdg-email-label{
      font-size:15px;
    }
    input.mm-prv-read-wdg-email{
      min-width: 200px;
      border: 1px solid silver;
      padding: $ge-padding;
      font-size:12px;
      border-radius: 2px;
      background: #f8f8f8;

    }
    .mm-prv-read-wdg-email-container{

      margin-bottom:10px
    }

    .email-sent-text {
      margin-left:12px;
      font-size: 12px;
      position:relative;
      top:-4px;
    }
    .mm-prv-read-wdg-request-text {

      margin-bottom:30px;
      label {
        font-size:14px;
      }

    }
  }
</style>



// WEBPACK FOOTER //
// src/App.vue